import React from 'react';

import { cn } from '@/_helpers/cn';

interface props {
  children: React.ReactNode;
  className?: string;
}

export const Island = ({ children, className }: props) => (
  <div className={cn('mb-6 rounded-lg border border-gray-100 bg-white px-12 py-10', className)}>{children}</div>
);

Island.displayName = 'Island';
